// 折りたたみ＋more。入りきらない項目にだけボタンを出し、max-height のトランジションで開閉する。
// 同じ並びの中で見出しがいちばん低い項目を基準にし、見出しが折り返した分は本文から差し引いて高さを揃える。
//
// マークアップの約束
//   グループ: [data-clamp] + data-clamp-lines="行数"（0で折りたたまない）
//             data-clamp-max-width="1024" を付けるとその幅以下でだけ折りたたむ
//   項目:     [data-clamp-item]（画像の下から測るため、直下の figure は読み飛ばす）
//   中身:     .clampBox（畳む箱）と、その直後の .moreBtn
(function () {
  function bind(box, btn) {
    if (btn.dataset.clampBound) return;
    btn.dataset.clampBound = '1';
    btn.addEventListener('click', function () {
      if (box.classList.contains('open')) {
        // 閉じる: none→px化してから閉じ高さへトランジション
        box.style.maxHeight = box.scrollHeight + 'px';
        void box.offsetHeight;
        box.style.maxHeight = parseFloat(box.dataset.closedH) + 'px';
        box.classList.remove('open');
        box.classList.add('clamped');
        btn.textContent = 'more';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        box.classList.add('open');
        box.classList.remove('clamped');
        box.style.maxHeight = box.scrollHeight + 'px';
        btn.textContent = 'close';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    box.addEventListener('transitionend', function (ev) {
      if (ev.propertyName === 'max-height' && box.classList.contains('open')) {
        // 開状態が確定したら高さ固定を解除し、以後の再折返しに追従させる
        box.style.maxHeight = 'none';
      }
    });
  }

  function measure(group) {
    var lines = parseFloat(group.dataset.clampLines);
    if (isNaN(lines)) lines = 0;
    // 幅の判定はCSSのメディアクエリと同じ土俵で行う（innerWidthはスクロールバー分ずれる）
    var maxWidth = parseFloat(group.dataset.clampMaxWidth);
    var withinWidth = isNaN(maxWidth) || window.matchMedia('(max-width: ' + maxWidth + 'px)').matches;
    var active = lines > 0 && withinWidth;

    var entries = [];
    group.querySelectorAll('[data-clamp-item]').forEach(function (item) {
      var box = item.querySelector('.clampBox');
      var btn = box && box.nextElementSibling;
      if (!box || !btn || !btn.classList.contains('moreBtn')) return;
      // 画像より下の先頭要素（サブ見出し、無ければ見出し）
      var head = null;
      for (var i = 0; i < item.children.length; i++) {
        if (item.children[i].tagName !== 'FIGURE') {
          head = item.children[i];
          break;
        }
      }
      if (!head) return;
      entries.push({
        box: box,
        btn: btn,
        txt: box.querySelector('.rte') || box,
        // 見出しまでの高さ。見出しが折り返すと項目ごとに変わる
        headH: box.getBoundingClientRect().top - head.getBoundingClientRect().top,
      });
    });
    if (!entries.length) return;

    var baseHead = Math.min.apply(
      null,
      entries.map(function (e) {
        return e.headH;
      })
    );
    entries.forEach(function (e) {
      bind(e.box, e.btn);
      if (e.box.classList.contains('open')) return;
      if (!active) {
        e.box.style.maxHeight = 'none';
        e.box.classList.remove('clamped');
        e.btn.hidden = true;
        return;
      }
      var lh = parseFloat(getComputedStyle(e.txt).lineHeight);
      if (isNaN(lh)) lh = parseFloat(getComputedStyle(e.txt).fontSize) * 2;
      var closedH = Math.max(lh, lh * lines - (e.headH - baseHead));
      e.box.dataset.closedH = closedH;
      var clipped = e.box.scrollHeight > closedH + lh * 0.5;
      e.box.style.maxHeight = clipped ? closedH + 'px' : 'none';
      e.btn.hidden = !clipped;
      e.box.classList.toggle('clamped', clipped);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-clamp]').forEach(measure);
  }
  window.ClampMore = { init: init };

  function initAll() {
    init(document);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Webフォント適用で行の折返しが変わるため再判定（開いている項目はスキップ）
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(initAll);
  // 画面幅が変わると見出しの折返し行数が変わるため測り直す
  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(initAll, 200);
  });
  // テーマエディタでのセクション再描画に追従
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
